// AJAX Utilities
$.ajaxErrorHandler = function (e) {
  alert(
    "We're having trouble sending your response. Please check your Internet connection and try again. If you're still having trouble, drop us a line at support@cultureamp.com"
  );
};
$.closestFormSubmitHandler = function (e) {
  $(e.target).closest('form').submit();
};
$.formAjaxSubmitHandler = function (e) {
  e.preventDefault();
  $(e.target).ajaxSubmit();
  return false;
};
$.fn.ajaxSubmit = function () {
  var $form = $(this[0]);
  var opts = {
    type: $form.attr('method'),
    data: $form.serialize(),
    error: $.ajaxErrorHandler,
  };
  $.ajax($form.attr('action'), opts);
};

$.timeAsString = function () {
  var currentTime = new Date();
  var hours = currentTime.getHours(),
    minutes = currentTime.getMinutes(),
    seconds = currentTime.getSeconds();
  var am_pm = hours > 11 ? 'PM' : 'AM';
  if (hours > 12) hours -= 12;
  if (minutes < 10) minutes = '0' + minutes;
  if (seconds < 10) seconds = '0' + seconds;
  return hours + ':' + minutes + ':' + seconds + ' ' + am_pm;
};

var $document = $(document);

!(function ($) {
  var dependentOptions = {};
  var parentQuestions = {};
  var dependentQuestionParents = {};
  var parentQuestionSelectedOptions = {};
  $(function () {
    // Find all parent questions that have a selected option
    // Iterate over questions that have select options with the attr data-dependent-questions
    $('.question:has(input[data-dependent-questions])').each(function () {
      var $question = $(this);
      parentQuestionSelectedOptions[$question.attr('id')] =
        getSelectedOptionIds($question);
      // Add this parent question id to the parentQuestions object
      parentQuestions[$question.attr('id')] = {};
      // Iterate over all the select options for this parent question with attr data-dependent-questions
      $question.find('input[data-dependent-questions]').each(function () {
        var $input = $(this);
        var qs = $input.attr('data-dependent-questions');
        if (qs != undefined) {
          var questionArray = [];
          // Get the dependent question ids
          var question_ids = qs.split(',');
          // We are assuming a child question only has one parent.
          mapDependentQuestionToParent(question_ids, $question.attr('id'));
          // Map dependent questions to a parent
          // iterate over each question_id and add a # to the id string
          for (var i = 0; i < question_ids.length; i++) {
            questionArray.push($('#' + question_ids[i]));
          }
          parentQuestions[$question.attr('id')][
            // The parent option id is added as a key to the parent question key in the dependent question object
            $input.data('option-id')
            // Add the question array with the dependent question ids to the dependentQuestion object
          ] = questionArray;
        }
      });
    });

    $('.question:has(input[data-dependent-questions])').each(function () {
      $(this).update_dependent_questions();
    });

    $('.theme').adjust_theme_totals();
  });
  // This gets called when submitting an answer. i.e. selecting a select option
  $document.on('submitting', '.question', function (e, answered) {
    var $question = $(this);
    // Update the parent questions selected options
    if (isParent($question.attr('id'))) {
      parentQuestionSelectedOptions[$question.attr('id')] =
        getSelectedOptionIds($question);
    }
    $question.update_dependent_questions();

    $('.three-sixty-save-status').removeClass('-saved').addClass('-saving');

    // Adjust all theme totals, not just the containing one, because the
    // visibility of other questions can depend on the response to this one.
    $('.theme').adjust_theme_totals();
  });
  // This gets called when a select option gets either selected or unselected or when the page is loading
  jQuery.fn.update_dependent_questions = function () {
    var $question = $(this);
    const questionId = $question.attr('id');
    var parentQuestionOptionHash = parentQuestions[questionId];
    if (typeof parentQuestionOptionHash !== 'undefined') {
      // Start by declaring all the dependent questions as 'not required'
      hideDependentQuestions([], parentQuestionOptionHash);

      // Finds all the options that are selected
      var selectedValues = getSelectedOptionIds($question);

      // Now show the dependent questions that map to at least one currently selected option.
      showDependentQuestions([], selectedValues, parentQuestionOptionHash);
    }
  };

  function mapDependentQuestionToParent(dependentQuestionIds, parentId) {
    for (let i = 0; i < dependentQuestionIds.length; i++) {
      dependentQuestionParents[dependentQuestionIds[i]] = parentId;
    }
  }

  function isRequiredToShowByParent(
    selectedParentOptions,
    dependentQuestionId
  ) {
    const parentSelectedOptionDependentQuestionIds = [];
    selectedParentOptions.forEach(function (selectedParentOptionId) {
      $(
        `input[data-select-option="${selectedParentOptionId}"][data-dependent-questions]`
      ).each(function () {
        let $input = $(this);
        parentSelectedOptionDependentQuestionIds.push(
          ...$input.attr('data-dependent-questions').split(',')
        );
      });
    });

    return parentSelectedOptionDependentQuestionIds.includes(
      dependentQuestionId
    );
  }

  function isParent(questionId) {
    return Object.prototype.hasOwnProperty.call(parentQuestions, questionId);
  }

  function getSelectedOptionIds(question) {
    const selectedIds = question
      .find('input[data-select-option][value=true]')
      .map(function (_key, option) {
        return $(option).data('option-id');
      });

    return $.makeArray(selectedIds);
  }

  function hideDependentQuestions(toggledQuestions, parentQuestionOptionHash) {
    for (var k in parentQuestionOptionHash) {
      // use hasOwnProperty to filter out keys from the Object.prototype
      if (Object.prototype.hasOwnProperty.call(parentQuestionOptionHash, k)) {
        for (var i = 0; i < parentQuestionOptionHash[k].length; i++) {
          const dependentQuestion = parentQuestionOptionHash[k][i];
          deepToggleDependentQuestion(
            toggledQuestions,
            dependentQuestion,
            true
          );
        }
      }
    }
  }

  function showDependentQuestions(
    toggledQuestions,
    selectedValues,
    parentQuestionOptions
  ) {
    selectedValues.forEach(function (selectedValue) {
      if (Object.keys(parentQuestionOptions).includes(selectedValue)) {
        var questionArray = parentQuestionOptions[selectedValue];
        if (typeof questionArray !== 'undefined') {
          for (var i = 0; i < questionArray.length; i++) {
            deepToggleDependentQuestion(
              toggledQuestions,
              questionArray[i],
              false
            );
          }
        }
      }
    });
  }

  function deepToggleDependentQuestion(
    toggledQuestions,
    dependentQuestion,
    hide
  ) {
    const questionId = dependentQuestion.attr('id');
    // When hiding, the dependent question might also be a parent in which case if we want to hide its dependent questions.
    if (
      hide &&
      isParent(questionId) &&
      !toggledQuestions.includes(questionId)
    ) {
      // no matter what, the dependent question is getting hidden
      dependentQuestion.toggleClass('not-required', hide);
      // To avoid infinite loops we tag the questionId in the toggledQuestions array.
      // If this questionId comes around again during this hide cycle it will skip the recursive call.
      toggledQuestions.push(questionId);
      var parentQuestionOptionHash = parentQuestions[questionId];
      hideDependentQuestions(toggledQuestions, parentQuestionOptionHash);
      return;
    }

    if (
      !hide &&
      isParent(questionId) &&
      !toggledQuestions.includes(questionId)
    ) {
      // just return if the dependent question is not required to show
      var selectedValues = getSelectedOptionIds(dependentQuestion);
      var parentQuestionOptionHash = parentQuestions[questionId];
      // show the dependent question
      dependentQuestion.toggleClass('not-required', hide);
      toggledQuestions.push(questionId);
      // also show all this dependent questions children and their children if relevant
      showDependentQuestions(
        toggledQuestions,
        selectedValues,
        parentQuestionOptionHash
      );
      return;
    }

    if (
      !hide &&
      !isParent(questionId) &&
      !!parentQuestionSelectedOptions[dependentQuestionParents[questionId]] &&
      !isRequiredToShowByParent(
        parentQuestionSelectedOptions[dependentQuestionParents[questionId]],
        questionId
      )
    ) {
      return;
    }

    dependentQuestion.toggleClass('not-required', hide);
  }

  jQuery.fn.adjust_theme_totals = function () {
    $(this).each(function () {
      var $theme = $(this);
      var total_displayed = $theme.find(
        '.question:not(.no-options):not(.not-required)'
      ).length;
      $theme.attr('data-questions', total_displayed);
      $theme.find('span.displayed').text(total_displayed);
      $theme.toggleClass('empty', total_displayed == 0);
    });
  };

  // Utility function that prevents default and nothing more
  $.preventDefaultHander = function (e) {
    e.preventDefault();
  };

  // Assigns values to the various data elements. These assignments
  // will be used to revert the object if a call fails
  $document.on('remember', 'input, textarea', function (e) {
    var $this = $(this);
    $this.attr('data-remember', $this.val());
  });

  // The reverse. Reset values based on their remembered values.
  // Right now we don't revert textareas - this might take some thought.
  $document.on('revert', 'input', function (e) {
    var $this = $(this);
    var remember = $this.attr('data-remember');
    if (typeof remember === 'undefined') return;
    $this.val(remember);
    if ($this.attr('type') == 'hidden') $this.change(); // Hidden fields need triggering
  });

  // Forms in these questions will submit via AJAX by default
  // Trigger "submit" event on the question to submit it correctly
  $document.on('submit', 'li.question form', $.preventDefaultHander);
  $document.on(
    'submit',
    '.free-text, li.classify, li.segment',
    function (e, answered) {
      $(this).trigger('submitting', answered);
      $(this).submit_question(answered);
    }
  );

  jQuery.fn.submit_question = function (answered) {
    if (answered == undefined) {
      answered = true;
    }
    var $this = $(this);
    var $form = $this.find('form');

    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: $form.serialize(),
      success: function (data, status, xhr) {
        // mark the question as answered and move on
        answered ? $this.trigger('answered') : $this.trigger('unanswered');
        $('.save-status').html('Last saved at ' + $.timeAsString());
        $('.three-sixty-save-status').removeClass('-saving').addClass('-saved');
      },
      error: function (e) {
        // Revert the fields and warn the user
        $this.find('input').trigger('revert');
        $.ajaxErrorHandler(e);
        $('.three-sixty-save-status').removeClass('-saving');
      },
    });
  };
})(jQuery);
